module.exports = __webpack_public_path__ + "img/us-quotation-popup-bg@2x.02b6a49c.png";